import { Navigate, Outlet } from 'react-router-dom';

import { useIsConservation } from '@/hooks/useIsConservation';
import { useMatchCurrentPage } from '@/hooks/useMatchCurrentPage';
import { usePathSet } from '@/hooks/usePathSet';

export const HomePageProtection = () => {
  const pathSet = usePathSet();
  const isLandingPage = useMatchCurrentPage(['/landsteward/home', '/buyer/home', '/staff/home']); // Harcode pages since paths is overwritten in usePathSet

  const isConservation = useIsConservation(); // Old conservation dashboards

  if (isLandingPage && isConservation) {
    return <Navigate to={pathSet.projects} replace />;
  }

  return <Outlet />;
};
